import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'
Vue.use(Router)

export function createRouter () {
  const router = new Router({
    routes
  })

  router.beforeEach(async (to, from, next) => {
    /* 设置title */
    if (store && store.state && store.state.actInfo) {
      router.app.$setDocumentTitle(store.state.actInfo.title)
    }
    // 路由拦截
    if (to.meta.requireAuth) {
      if (store.state.actInfo) {
        next()
      } else {
        next({
          path: '/loading'
        })
      }
    }
    next()
  })
  router.afterEach(async (to, from) => {
    if (to.meta.needScrollTop) {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
    }
  })

  return router
}
